import { render } from "./MaterialAlert.vue?vue&type=template&id=1768176e"
import script from "./MaterialAlert.vue?vue&type=script&lang=js"
export * from "./MaterialAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__